export const rules = {
  title: { en: 'Rules', ko: '권한', fr: '' },
};
